import { inject } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { Router } from '@angular/router';
import { filter, map } from 'rxjs';
import { NtaFacilityStore } from './facility.store';

export const facilityLayoutEnabledGuard = () => {
	const store = inject(NtaFacilityStore);
	const router = inject(Router);

	return toObservable(store.facilityLoaded).pipe(
		filter((facilityLoaded) => facilityLoaded),
		map(() => {
			if (!store.facilityLayoutEnabled()) {
				router.navigate(['/settings/users']);
			}
			return store.facilityLayoutEnabled();
		})
	);
};
